<template>
    <div>
        <div class="form-group" v-if="isAccountsReceivable && timeEntry.sendEmail === 'Yes'">
            <label for="attachInvoice" class="col-sm-2 control-label">
                Attach invoice to email?
            </label>
            <div class="col-sm-6">
                <div class="radio">
                    <label for="attachInvoiceYes" class="radio-inline">
                        <input type="radio" name="attachInvoice" id="attachInvoiceYes" value="Yes" v-model="timeEntry.attachInvoice" :disabled="timeEntry.isAuditEdit">
                        Yes
                    </label>
                    <label for="attachInvoiceNo" class="radio-inline">
                        <input type="radio" name="attachInvoice" id="attachInvoiceNo" value="No" v-model="timeEntry.attachInvoice" :disabled="timeEntry.isAuditEdit">
                        No
                    </label>
                </div>
            </div>
        </div>

        <email-to v-if="timeEntry.sendEmail === 'Yes' && !$store.getters.isEditForm" @contactPickerClick="pickContact">
        </email-to>

        <div class="form-group" v-if="$store.getters.restrictedEditMode && timeEntry.emailTo">
            <label class="col-sm-2 control-label">To:</label>
            <div class="col-sm-8 col-md-6">
                <input type="text" class="form-control" disabled="disabled" :value="timeEntry.emailTo" />
            </div>
        </div>

        <div v-if="(!$store.getters.isEditForm || disabled) && (timeEntry.sendEmail === 'Yes' || timeEntry.sendEmail === null)" class="form-group" :class="{'has-error': errors.has('emailFrom')}">
            <label for="emailFrom" class="col-sm-2 control-label">From:</label>
            <div v-if="!$store.getters.restrictedEditMode" class="col-sm-8 col-md-6">
                <input v-validate.disable="'required'" data-vv-as="from" type="text" class="form-control"
                       id="emailFrom" name="emailFrom" :value="emailFrom" disabled="disabled" />
                <p class="text-danger" v-if="errors.has('emailFrom')">{{ errors.first('emailFrom') }}</p>
            </div>
            <div v-else-if="timeEntry.sendEmail === 'Yes'" class="col-sm-8 col-md-6">
                <input type="text" class="form-control" disabled="disabled" :value="emailFrom" />
            </div>
        </div>

        <template v-if="timeEntry.sendEmail === 'Yes' || disabled">
            <div class="form-group" :class="{'has-error': errors.has('comment')}">
                <label for="comment" class="col-sm-2 control-label">Subject:</label>
                <div v-if="!disabled" class="col-sm-10 col-md-8">
                    <input v-validate.disable="'required'" data-vv-as="subject" type="text" class="form-control"
                           id="comment" name="comment" v-model="timeEntry.comment"
                           placeholder="Enter the subject for the email" maxlength="100 "/>
                    <p class="text-danger" v-if="errors.has('comment')">{{ errors.first('comment') }}</p>
                </div>
                <div v-else class="col-sm-6">
                    <p>{{ timeEntry.comment }}</p>
                </div>
            </div>

            <div class="form-group" :class="{'has-error': errors.has('noteText')}">
                <label for="noteText" class="col-sm-2 control-label">Message:</label>
                <div v-if="!disabled" class="col-sm-10 col-md-8">
                    <textarea v-validate.disable="'required'" data-vv-as="Message" class="form-control" rows="3"
                              id="noteText" name="noteText" v-model="timeEntry.noteText"></textarea>
                    <p class="text-danger" v-if="errors.has('noteText')">{{ errors.first('noteText') }}</p>
                </div>
                <div v-else class="col-sm-10 col-md-8">
                    <p>
                        <note-body :note-text="timeEntry.noteText" :collapsible="false"></note-body>
                    </p>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Vue from "vue";
    import EmailTo from "./email-to";
    import NoteBody from "../shared/note-body.vue";

    Vue.component("email-to", EmailTo);
    Vue.component("note-body", NoteBody);

    export default {
        inject: ['$validator'],
        data: function () {
            return {
                timeEntry: this.$store.state.timeEntry,
            };
        },
        methods: {
            pickContact(url) {
                this.$emit('contactPickerClick', url);
            }
        },
        props: {
            isAccountsReceivable: Boolean,
            emailFrom: String,
            disabled: Boolean
        }
    };
</script>